import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchPersonalInfo, PersonalInfo } from '../data/contentService';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [personalInfo, setPersonalInfo] = useState<PersonalInfo | null>(null);
  const location = useLocation();

  useEffect(() => {
    const loadPersonalInfo = async () => {
      try {
        const info = await fetchPersonalInfo();
        setPersonalInfo(info);
      } catch (error) {
        console.error('Error loading personal info:', error);
      }
    };

    loadPersonalInfo();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <h1>{personalInfo?.name || 'Tommy Maaiveld'}</h1>
            <span className="subtitle">{personalInfo?.title || 'Research Scientist'} at {personalInfo?.affiliation || 'TNO'}</span>
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <Link 
                  to="/" 
                  className={`nav-link ${isActive('/') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/publications" 
                  className={`nav-link ${isActive('/publications') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Publications
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/contact" 
                  className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          <button 
            className={`menu-toggle ${isMenuOpen ? 'menu-open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        
      </div>
    </header>
  );
};

export default Header;
